import { getFEWalletParams } from '../../../platform.pay.config'
import { DefaultDate } from '../../../platform.es.config'
/* 金额分割 */
export const numberWithCommas = (num) => {
	return num && num != '' ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0';
};
export const NamewithAsterisk = (name) => {
	let nameAsterisk = ''
	if (name && name != '') {
		let nameList = name.toString().trim().split(' ')
		nameList.forEach((item) => {
			nameAsterisk = `${nameAsterisk} ${item.slice(0, 1)}******`
		})
	}
	return nameAsterisk
}
//时间
export const dateTime = (num = '') => {
	if(!num) {
		return '--:--'
	}
	let date = new Date((new Date()).getTime() + num)
	return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
};

//sessionStorage缓存,web mobile刷新页面使用
let Storage = {}
export const SetStorage = (key, value) => {
	Storage[key] = value
	const { device } = GetParamsData()
	if(device != 'APP') {
		sessionStorage && sessionStorage.setItem(key, JSON.stringify(value))
	}
}
//缓存
export const GetStorage = (key) => {
	let data = Storage[key] || ''
	const { device } = GetParamsData()
	if(device != 'APP') {
		data = sessionStorage && sessionStorage.getItem(key)
		data = JSON.parse(data)
	}
	return data
}

export const bankCodeWriting = (item = '') => {
	if (item && item != '') {
		return item.replace(/\s/ig, '').replace(/[\.\(\),-]/g, '').toLocaleUpperCase()
	}
	return 'default'
}
//对外交互方法
export function GetParamsData() {
	return getFEWalletParams() || {}
}
//api提交默认参数
export const PostDepositDefaultDate = () => {
	const { device, platformType, languageType } = GetParamsData()
	const platformDate = DefaultDate[(platformType + languageType)][device] || {}

	return platformDate
}

export const MethodList = ['BQR', 'CC', 'LB', 'THBQR', 'EZP', 'BC', 'TMW', 'CTC', 'LINE', 'RD']
